var Gesture = /** @class */ (function () {
    function Gesture(gm) {
        this.EVENT = 'gesture';
        this.gm = gm;
    }
    /**
     * 处理事件
     * @param ev
     */
    Gesture.prototype.do = function (ev) {
        var type = ev.type;
        switch (type) {
            case 'touchstart':
                this.onTouchStart(ev);
                break;
            case 'touchmove':
                this.onTouchMove(ev);
                break;
            case 'touchend':
                this.onTouchEnd(ev);
                break;
            case 'touchcancel':
                this.onTouchCancel(ev);
                break;
            default:
                return;
        }
    };
    /**
     * 触发事件
     * @param e
     */
    Gesture.prototype.emit = function (e) {
        this.gm.emit(this.EVENT, e);
    };
    return Gesture;
}());
export { Gesture };
//# sourceMappingURL=gesture.js.map